/**
 * Given a string `_tableType` created from `kindToTableType`, determine whether a table is a config.
 *
 * Note: If the provided string is null, default to false and assume table is not a config.
 */
export default function isTableConfig(_tableType?: string | null): boolean {
  return _tableType?.includes('config_') ?? false;
}
